import React, {useContext, useEffect, useState} from 'react'
import {Modal, ModalBody} from 'reactstrap'
import strings from '../../../lang/strings'
import {observer} from 'mobx-react'
import AppInput from '../custom_input/app_input'
import {formatNumber} from '../../../helper/common'
import ConfirmButton from '../button/confirm_button'
import {Page_settings} from '../../../config/page_settings'
import {rootStore} from '../../../mobx/store'

const PointPayModal = observer((props) => {
  const context = useContext(Page_settings)
  const {show, toggle} = props
  let [mode, setMode] = useState(3) //1:실시간계좌이체, 2:휴대폰소액결제, 3: 무통장입금
  let [pointIndex, setPointIndex] = useState(-1)
  let [point, setPoint] = useState(0)
  let [error, setError] = useState('')
  let [vatFee, setVatFee] = useState(10)

  let [payer, setPayer] = useState('')
  let [payerError, setPayerError] = useState('')
  let [sendSms, setSendSms] = useState(false)
  let [phone, setPhone] = useState('')
  let [phoneError, setPhoneError] = useState('')

  useEffect(() => {
    context.post('conf/get_conf', {type: 'vat_fee'},
      response => {
        setVatFee(parseInt(response.conf ?? 10))
      }
    )

    setPayer('')
    setPayerError('')
    setSendSms(false)
    setPhone('')
    setPhoneError('')

  }, [])

  useEffect(() => {
    setError('')
  }, [point])

  useEffect(() => {
    setPayerError('')
  }, [payer])

  useEffect(() => {
    setPhoneError('')
  }, [phone])

  const initModal = () => {
    reset()
    setMode(3)
  }

  const reset = () => {
    setPoint(0)
    setPointIndex(-1)
  }

  const addPoint = (i, p) => {
    setPointIndex(i)
    setPoint(prev => prev + Number(p))
  }

  const onConfirm = () => {
    if (point == '' || point == 0) {
      setError(strings.point_pay_hint)
      return
    }
    if (mode === 3) {
      if (payer === '') return setPayerError(strings.payer_name_enter)
      if (sendSms && phone === '') return setPhoneError(strings.invalid_hint)
      const amount = point * (100 + vatFee) / 100
      context.post('pay/nobank_request', {amount: amount, point: point, payer: payer, sendSms: sendSms ? 1 : 0, phone: phone},
        response => {
          let mb = rootStore.getMe
          mb.mb_point = response.mb_point
          rootStore.signIn(mb)
          context.addNotification('', strings.pay_requested)
          props.onNobank(point, vatFee, payer)
        }
      )
      return
    }
    props.onProc(mode, point, vatFee)
  }

  const onClose = () => {
    initModal()
    toggle()
  }

  const changePoint = (v) => {
    let p = parseInt(v)
    if (isNaN(p)) p = 0
    setPoint(parseInt(p))
  }

  return (
    <Modal isOpen={show} toggle={() => onClose()} className='modal-point-pay'>
      <ModalBody>
        <div className='modal-header-custom d-center position-relative'>
          <div className='fs-20 sm-fs-18 f-b'>{strings.point_pay}</div>
          <div className='modal-close-btn d-center position-absolute' onClick={() => onClose()}>
            <img src={'/assets/image/close.png'} alt='' className='modal-close'/>
          </div>
        </div>
        <div className='modal-content-area ph-40 sm-ph-15 pv-40 text-center fs-16 sm-fs-15 f-m'>
          <div hidden={true} className='pb-20 fs-18 sm-fs-14 f-m'>{strings.point_pay_hint}</div>
          <div className='d-flex d-center'>
            <div onClick={() => {addPoint(0, 10000)}} className={'flex-full d-center ' + (pointIndex === 0 ? 'btn-point-active' : 'btn-point-normal')}>{'10,000'}</div>
            <div onClick={() => {addPoint(1, 30000)}} className={'flex-full d-center ml-8 ' + (pointIndex === 1 ? 'btn-point-active' : 'btn-point-normal')}>{'30,000'}</div>
            <div onClick={() => {addPoint(2, 50000)}} className={'flex-full d-center ml-8 ' + (pointIndex === 2 ? 'btn-point-active' : 'btn-point-normal')}>{'50,000'}</div>
            <div className='wx-60 ml-8'>
              <div onClick={reset} className={'flex-full d-center btn-point-normal color-e45a5a'}>{strings.reset}</div>
            </div>
          </div>
          <div className='pt-10 d-flex d-center'>
            <div onClick={() => {addPoint(3, 100000)}} className={'flex-full d-center ' + (pointIndex === 3 ? 'btn-point-active' : 'btn-point-normal')}>{'100,000'}</div>
            <div onClick={() => {addPoint(4, 200000)}} className={'flex-full d-center ml-8 ' + (pointIndex === 4 ? 'btn-point-active' : 'btn-point-normal')}>{'200,000'}</div>
            <div onClick={() => {addPoint(5, 300000)}} className={'flex-full d-center ml-8 ' + (pointIndex === 5 ? 'btn-point-active' : 'btn-point-normal')}>{'300,000'}</div>
            <div onClick={() => {}} hidden={true} className={'flex-full d-center ml-8 ' + (pointIndex === 6 ? 'btn-point-active' : 'btn-point-normal')}>{strings.direct_input}</div>
            <div className='wx-60 ml-8'></div>
          </div>
          {
            pointIndex === 6 &&
            <div className='pt-20 w-100'>
              <div className=' fs-15 text-left'>{strings.direct_input}</div>
              <AppInput center={true} className={'mt-6'} errorMsg={error} placeholder={'12,000'} inputType={'number'} value={point} onChange={(v) => {changePoint(v)}} />
            </div>
          }
          <div className='divider mt-20 sm-mt-20' />
          <div className='pt-20 d-flex'>
            <div className='fs-16 f-mb text-left flex-full'>{strings.total_buy_point}</div>
            <div className='fs-18 sm-fs-16 f-mb color-0a3962'>{formatNumber(point)}</div>
          </div>
          <div className='pt-10 d-flex' style={{alignItems : 'center'}}>
            <div className='fs-18 sm-fs-16 f-b text-left flex-full'>{strings.pay_amount}</div>
            <div className='fs-22 sm-fs-16 f-b color-0a3962'>{formatNumber(point * (100 + vatFee) / 100)} {strings.won}</div>
          </div>
          <div className='pt-15 d-flex fs-15'>
            <div onClick={() => {setMode(1)}} hidden={true} className={'d-center ' + (mode === 1 ? 'btn-mode-chk' : 'btn-mode')}>{strings.paymode_trans}</div>
            <div onClick={() => {setMode(2)}} hidden={true} className={'d-center m-5 ' + (mode === 2 ? 'btn-mode-chk' : 'btn-mode')}>{strings.paymode_phone}</div>
            <div onClick={() => {setMode(3)}} className={'d-center ' + (mode === 3 ? 'btn-mode-chk' : 'btn-mode')}>{strings.paymode_nobank}</div>
          </div>
          {
             mode === 3 &&
             <div className='mt-10'>
             <div className='mb-2 fs-14 text-right space-break color-fa2222 f-sb'>{strings.point_guide_hint}</div>
             <div className='d-center'>
               <label className='control-label wx-100 text-left mb-0 f-m'>{strings.payer_name}</label>
               <AppInput className='flex-full' errorMsg={payerError} placeholder={strings.payer_name_hint} inputType={'text'} maxLength={20} value={payer} onChange={(v) => { setPayer(v) }} />
             </div>
             <div className='d-center mt-5' hidden={true}>
               <div className='d-flex align-items-center cursor-point' onClick={() => setSendSms(!sendSms)}>
                 <img className='checkbox' src={sendSms ? '/assets/image/chk_on.png' : '/assets/image/chk.png'} alt='' />
                 <div className='fs-14 color-9e9e9e ml-10'>{strings.send_sms}</div>
               </div>
               <AppInput className='flex-full ml-10' errorMsg={phoneError} placeholder={strings.phone} inputType={'tel'} value={phone} onChange={(v) => { setPhone(v) }} />
             </div>
           </div>
          }
          <div className='mt-20 fs-14 text-left space-break color-fa2222 f-sb'>{strings.pay_refund1}</div>
          <div className='mt-2 fs-14 text-left space-break f-m'>{strings.pay_refund2}</div>
          <div className='mt-2 fs-14 text-left space-break f-m'>{strings.pay_refund3}</div>
          <ConfirmButton enabled={true} className={'mt-25 sm-mt-14 btn btn-confirm fs-15 f-sb d-center'} onClick={onConfirm} text={strings.point_pay} />
        </div>
      </ModalBody>
    </Modal>
  )
})

export default PointPayModal
